/**
 * Assets del producto DPS64 · Small Engine Diagnostic Pro.
 *
 * Todavía no hay mockup ni páginas exportadas de Gamma (la carpeta
 * Drive > Producto - DPS64 > product está vacía). Con todo vacío, la página
 * muestra una pila de tomos y vistas previas diseñadas con la identidad del pack.
 *
 * MAIN_MOCKUP_URL: mockup principal (hero y recuadro de precio). Pegá la URL pública.
 * PAGE_IMAGES: páginas reales de los tomos (formato horizontal 4:3). Si una URL
 * se completa, reemplaza a la vista previa diseñada de esa página.
 */
export const MAIN_MOCKUP_URL = ''

export const PAGE_IMAGES = {
  fourGates: '', // Vol. 1 p.6 · The 4-Gate Diagnostic Sequence
  surgeCard: '', // Vol. 2 · BC-34 Still Surging After a Carb Clean
  carbGate: '', // Vol. 3 p.15 · The Carb Decision Gate
  seatSwitch: '', // Vol. 4 · BC-104 Test a Seat Switch
  compression: '', // Vol. 5 p.13 · Compression Verdict Chart
  repairOrder: '', // Vol. 6 · WS-19 Repair Order
}
